<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      <div class="pb-1 button-center">
        <modal-link modal-id="How to Use" :content-list="pageContent" :image-size="'large'"></modal-link>Ranks
        <smart-center-link page="Moats" location="Header" />
      </div>
      <div class="ml-auto">
        <i v-show="this.$root.getShowMenuIcon() && this.$root.getShowHeaderMenu()"
          class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
        <i v-show="this.$root.getShowMenuIcon() && !this.$root.getShowHeaderMenu()"
          class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
      </div>
    </div>
    <saved-card-menu :entry-client-object="clientObject" :original-saved-cards="clientChartsBySurvey" set-type="survey" view-type="menu"></saved-card-menu>
    <div class="chart-app">
      <chart-criteria ref="chartCriteria" display-type-modal-name="Ranks" showUseTTMAsStartDate="true" :show-equal-weight="false" :use-chart-type-card="true" :content-list="pageContent" :is-comparative="false" 
      :show-include-organization-selected-in-group-ranks="true"
      @reset-client-chart="resetClientChart">
      </chart-criteria>
      <div class="row no-gutters">
        <div class="col">
          <div id="chartDislayCard">
            <div id="performance_dashboard">
              <div id="chart-filters" class="row">
                <chart-criteria-results ref="chartCriteriaResults" v-bind:criteria-results-list="criteriaResultsList"
                  v-show="!generatingChart && displayChartCriteriaResults"
                  v-bind:criteria-results-company-list="criteriaResultsCompanyList"></chart-criteria-results>
              </div>
              <chart-display-skeleton v-show="generatingChart"/>
              <MoneyballStickRank v-show="isMoneyballStickRank && !generatingChart" :input-data="moneyballStickRankData" :content-list="pageContent"></MoneyballStickRank>
              <BaseRank v-show="!generatingChart" :input-data="baseRankData" :input-data-for-competitors="baseRankDataForCompetitors" :content-list="pageContent" ></BaseRank>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay d-none">
      <img class="overlay-inner d-none" src="../../assets/img/overlap.png"  style="width: 50%"/>
    </div>
    <div v-for="(pageContent, idxPageContent) in pageContent" v-bind:key="idxPageContent">
      <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
    </div>
    <vue-modal ref="save-chart-confirmation" name="save-chart-confirmation" :width="350" :height="200">
      <save-chart :chart-title="this.chart.title" :initial-client-chart="this.clientChart" @save="updateClientCharts" @closeModal="closeModal('save-chart-confirmation')">
      </save-chart>
    </vue-modal>
    <vue-modal ref="auto-create-groups-of-tiers" name="auto-create-groups-of-tiers" :width="350" :height="250">
      <auto-create-groups :base-group-name="baseGroupName" :survey-group-by-tier-list="surveyGroupByTierList"
        @save="closeAutoGenerate" @closeModal="closeModal('auto-create-groups-of-tiers')"></auto-create-groups>
    </vue-modal>
  </div>


</template>
<script>

import ChartCompanyMixins from "../../mixins/ChartCompanyMixins.vue";
import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import SaveChart from "../../components/chart/SaveChart.vue";
import AutoCreateGroups from "../../components/chart/AutoCreateGroups.vue";
import MoneyballStickRank from "./type/MoneyballStickRank.vue";
import BaseRank from "./type/BaseRank.vue";
import ChartService from "../../services/chart.service";
import ErrorService from "../../services/error.service";
import AdminService from "../../services/admin.service";

export default {
  name: "Ranks",
  mixins: [ChartCompanyMixins],
  components: {
    SaveChart,
    AutoCreateGroups,
    MoneyballStickRank,
    BaseRank,
    ChartDisplaySkeleton
  },
  data() {
    return {
      title: "Ranks",
      pageNumber: 4,
      
      chartData: [],
      baseRankData: {},
      baseRankDataForCompetitors: {},
      moneyballStickRankData: {},
      surveyGroupByTierList: [],
      baseGroupName: "",
      isMoneyballStickRank: false,
      chartWidth: "",
      
    };
  },
  methods: {
    closeModal(name) {
      if(this.$refs[name] != null) {
        this.$refs[name].visible = false;
      }
    },
    closeAutoGenerate: function (value, message) {
      AdminService.displaySuccessMessage({ text: message });
      this.$refs['auto-create-groups-of-tiers'].visible = false;
    },
    async displayChartCallback(response) {
      try {
        this.$root.processServerResponse();
        this.generatingChart = false;

        this.chartData = response.data;
        this.baseRankData = JSON.parse(JSON.stringify(this.chartData[0])); 
        this.baseRankDataForCompetitors = {};
        let otherData = this.baseRankData["otherData"];
        if (typeof otherData["moneyballStickResults"] !== "undefined") {
          this.moneyballStickRankData = otherData["moneyballStickResults"];
          let titleSuffix = otherData["titleSuffix"];
          this.moneyballStickRankData.titleSuffix = titleSuffix;
        }
        this.isMoneyballStickRank = this.$refs.chartCriteria.$data.displayType == "moat-rank";
        if (this.isMoneyballStickRank == true) {
          if (this.chartData.length > 2) {
            this.baseRankDataForCompetitors = JSON.parse(JSON.stringify(this.chartData[2])); 
          }           
          let moatRankData = JSON.parse(JSON.stringify(this.chartData[1])); 
          this.setChartResults(moatRankData.companyList);
        }
      } catch (err) {
        ErrorService.processException("Ranks.displayChartCallback", err, "chart", this);
      }
    }
  },
  umnounted() { },
  computed: {},
  mounted() { },
  created() {
    this.chart = ChartService.getChartAttributes("Ranks");
  },
  props: {},
  watch: {}
};
</script>
